import React, { useCallback } from 'react';
import {
  FieldType,
  IFieldTypeParamsFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import { FieldLabel } from '../../../../components/Form';
import { SingleSelectMenu } from '../../../../components/Dropdown';
import {
  ARRAY_ITEM_FIELD_TYPE_OPTIONS,
  defaultFieldTypeParams,
} from '../utils';

interface IProps {
  typeParams: IFieldTypeParamsFieldsFragment;
  setTypeParams: (params: IFieldTypeParamsFieldsFragment) => void;
  readOnly?: boolean;
}

const DerivedColumnArrayItemTypeInput = ({
  typeParams,
  setTypeParams,
  readOnly,
}: IProps) => {
  const currentType = typeParams.arrayItemType ?? FieldType.String;

  const setCurrentType = useCallback(
    (s: string) => {
      setTypeParams(
        defaultFieldTypeParams({
          arrayItemType: s as FieldType,
          customDefinition: typeParams.customDefinition,
        }),
      );
    },
    [typeParams.customDefinition, setTypeParams],
  );

  return (
    <>
      <FieldLabel>Of</FieldLabel>
      <SingleSelectMenu
        value={currentType}
        options={ARRAY_ITEM_FIELD_TYPE_OPTIONS}
        onChange={setCurrentType}
        disabled={readOnly}
      />
    </>
  );
};

export default DerivedColumnArrayItemTypeInput;
